import { createBrowserRouter, Navigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
// Layout
import Layout from './components/layout/Layout';
// Páginas
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SeleccionCursoPage from './pages/SeleccionCursoPage';
import PlanificacionPage from './pages/PlanificacionPage';
import PeriodosPage from './pages/PeriodosPage';
import UnidadesPage from './pages/UnidadesPage';
import EnfoquesPage from './pages/EnfoquesPage';
import GenerarDocumentosPage from './pages/GenerarDocumentosPage';
import AdminPage from './pages/AdminPage';

const RequireCurso = ({ children }) => {
  const { user, isGuest } = useAuth();
  if (!user && !isGuest) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'seleccionar-curso', element: <SeleccionCursoPage /> },
      {
        path: 'planificacion',
        element: <RequireCurso><PlanificacionPage /></RequireCurso>,
      },
      {
        path: 'periodos',
        element: <RequireCurso><PeriodosPage /></RequireCurso>,
      },
      {
        path: 'unidades',
        element: <RequireCurso><UnidadesPage /></RequireCurso>,
      },
      {
        path: 'configuracion-final',
        element: <RequireCurso><EnfoquesPage /></RequireCurso>,
      },
      {
        path: 'generar-documentos',
        element: <RequireCurso><GenerarDocumentosPage /></RequireCurso>,
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
  // Ruta admin: fuera del Layout, pantalla limpia sin navbar/sidebar
  {
    path: '/admin',
    element: <AdminPage />,
  },
]);

export default router;
